import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';

export const ForgottenPasswordSuccess = () => {
  const dispatch = useTracking();

  useEffect(() => {
    dispatch({
      event: 'DisplayFormSuccess',
      DisplayFormSuccessData: {
        category: 'reset-password',
      },
    });
  }, [dispatch]);

  return (
    <div className="text-size-body-xs flex flex-col p-2" data-testid="forgot-password-success">
      <FormattedMessage
        id="ForgotPasswordSuccess.message"
        defaultMessage={
          'Geschafft!{break}' +
          'Wenn uns Ihre Mail-Adresse bekannt ist, bekommen Sie in wenigen Minuten eine Nachricht von uns.' +
          '{break}{break}' +
          'Klicken Sie einfach auf den Link oder kopieren diesen in Ihren Browser. Danach können Sie ein neues Passwort vergeben. Erst wenn Sie dieses bestätigt haben, wird Ihr altes Passwort gelöscht.' +
          '{break}{break}' +
          'Sie haben keine E-Mail erhalten? Schauen Sie mal in Ihren Spam-Ordner. Vielleicht ist sie aus Versehen dort gelandet.'
        }
        values={{ break: <br /> }}
      />
    </div>
  );
};

export default ForgottenPasswordSuccess;
